import { useContext } from 'react'

import { PostsWidgetContext } from '../../Posts.context'

export function usePostsWidgetContext() {
  return useContext(PostsWidgetContext)
}
